import { ref, watch, onMounted, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, isRef as _isRef, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/chat/chatBox/load.png';
import _imports_1 from '@/assets/images/chat/chatBox/select.png';
import _imports_2 from '@/assets/images/chat/chatBox/send.png';
const _withScopeId = n => (_pushScopeId("data-v-75b5a082"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "select_avatar",
  class: "select_avatar"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "avatar"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "loading"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "donut"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  key: 2,
  class: "error"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "失败", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_12 = [_hoisted_10, _hoisted_11];
const _hoisted_13 = ["title"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, "+", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加助手", -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = {
  key: 0,
  class: "label"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "avatar"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 0,
  class: "select_icon",
  src: _imports_1,
  alt: ""
};
const _hoisted_23 = ["placeholder", "onKeydown"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "send",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_25 = [_hoisted_24];
import chatgptHook from '../hooks/chatgpt';
import { jsRecorder } from '@/utils/audioRecord/record.js';
import bus from '@/utils/mitt.js';
import userHooks from '@/hooks/userHooks';
import roleHooks from '@/hooks/roleV2Hooks';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['uploadAudioStream'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const route = useRoute();
    const {
      getMessageTotalInfo,
      setUniqueId
    } = userHooks();
    let isInitPlayer = false;
    const {
      onwerAllRoleList,
      curSelectRoleInfo,
      setCurSelectRoleInfo,
      setDigitalDetail,
      avatarList,
      getRoleList,
      setIsShowLeft,
      set_visible,
      visible,
      isShowLeft
    } = roleHooks();
    const placeholder = ref('有问题尽管问我…');
    watch(isShowLeft, (nVal, oVal) => {
      if (nVal) {
        set_visible(false);
      }
    });
    const textarea = ref(null);
    const input = e => {
      textarea.value.style.height = 'inherit';
      textarea.value.style.height = e.target.scrollHeight + 'px';
    };
    const outClick = () => {
      if (visible.value) set_visible(false);
    };
    const selectAvatar = () => {
      if (!isFinshed.value) return;
      set_visible(!visible.value);
      // visible.value = !visible.value
      visible.value && getRoleList();
    };
    const messageSendlisten = event => {
      if (event.ctrlKey && event.keyCode === 13) {
        word.value += '\n';
        textarea.value.scrollTop = textarea.value.scrollHeight;
      } else if (event.keyCode === 13) {
        sendMessage();
        event.preventDefault();
        return false;
      }
    };
    const curAvatarIndex = ref(0);
    const slectAvatar = (item, index) => {
      if ([1, 4].includes(item.status)) {
        ElMessage.warning('该角色正在加载中，请稍后再试！');
        return;
      }
      if (item.status != 2) {
        ElMessage.warning('该角色加载失败，请重新编辑后再试！');
        return;
      }
      if (!isFinshed.value) return;
      // visible.value = false
      set_visible(false);
      curAvatarIndex.value = index;
      setCurSelectRoleInfo(item);
      setDigitalDetail();
    };
    const addAvatar = () => {
      setIsShowLeft(true);
      set_visible(false);
      // visible.value = false
    };

    onMounted(() => {
      window.addEventListener('beforeunload', function (event) {
        closeWebsocket();
      });
      window.addEventListener('onunload', function (event) {
        closeWebsocket();
      });
      setUniqueId();
      bus.on('flvEnd', setStatus);
    });
    onUnmounted(() => {
      bus.off('flvEnd', setStatus);
    });
    const setStatus = stat => {
      isFinshed.value = stat;
    };
    let websocket;
    const isRecording = ref(false);
    const startRecord = () => {
      navigator.mediaDevices.getUserMedia({
        audio: true
      }).then(stream => {
        isRecording.value = true;
        word.value = '';
        asrWebSocket();
        recStart();
      }).catch(error => {
        switch (error.message || error.name) {
          case 'PERMISSION_DENIED':
          case 'PermissionDeniedError':
            console.info('用户拒绝提供信息。');
            break;
          case 'NOT_SUPPORTED_ERROR':
          case 'NotSupportedError':
            console.info('浏览器不支持硬件设备。');
            break;
          case 'MANDATORY_UNSATISFIED_ERROR':
          case 'MandatoryUnsatisfiedError':
            console.info('无法发现指定的硬件设备。');
            break;
          default:
            console.info('无法打开麦克风。异常信息:' + (error.code || error.name));
            break;
        }
      });
    };
    const stopRecord = () => {
      isRecording.value = false;
      recStop();
      sendEnd();
    };
    const emitPlayer = () => {
      if (!isInitPlayer) {
        // console.log('emitPlayer11')
        bus.emit('initPlayer');
      }
      isInitPlayer = true;
    };
    const sendEnd = () => {
      websocket && websocket.send(JSON.stringify({
        signal: 'end'
      }));
    };
    const sendStart = () => {
      // 英文：DEDF3CF2BE1B2AC8B4BD3DA659EE3459，中文：8FA94097176F33241C728536CC8ED373
      const appKey = curSelectRoleInfo.value.name.includes('英语') ? 'DEDF3CF2BE1B2AC8B4BD3DA659EE3459' : '8FA94097176F33241C728536CC8ED373';
      websocket && websocket.send(JSON.stringify({
        'Accept-Encoding': 'gzip',
        'Content-Type': 'audio/x-wav;codec=pcm;bit=16;rate=16000',
        appkey: appKey,
        device_id: 'device-123',
        device_version: '',
        output_format: 'lite',
        partial_result: 'enable',
        silence_detection: 'enable',
        continuous_decoding: 'enable',
        remote_timeout: 600,
        sdk_version: '41000',
        signal: 'start',
        source: 'copilot',
        user_id: 'copilot',
        msg_id: 'copilot',
        version: '40000'
      }));
    };
    const asrWebSocket = () => {
      let protocol = 'ws';
      let url = '://auto.mobvoi.com/websocket/asr';
      // let url = '://asr-test.mobvoi.com/websocket'
      if (window.location.protocol == 'https:') {
        protocol = 'wss';
      }
      websocket = new WebSocket(`${protocol}${url}`);
      // 建立连接
      websocket.onopen = () => {
        // 发送数据
        console.log('websocket开启');
        sendStart();
      };
      // 客户端接收服务端返回的数据
      websocket.onmessage = evt => {
        if (evt.data) {
          const obj = JSON.parse(evt.data);
          console.log('websocket-asr返回的数据：', obj);
          if (obj.type == 'partial_result') {
            //实时结果返回 转成文字
            // word.value += obj.content
          } else if (obj.type == 'query_result') {
            //query_result
            word.value += obj.content + ' ';
          } else if (obj.type == 'onebox_header') {
            // 服务端发送对话结果前，会发送onebox_header通知消息。收到消息后，客户端需要准备对后续收到的websocket binary数据进行gzip解压得到字符串，并解析为json，为本轮对话结果
          } else if (obj.type == 'slience') {
            // slience server端监测到静音后
          } else if (obj.type == 'speech_end') {
            //服务端在解码结束后，会发送speech_end，并将最终结果存放在content字段。
            // 连续对话在这返回 continuous_decoding
            stopRecord();
            closeWebsocket();
          } else if (obj.type == 'result_end') {
            // 服务端在本轮结束时，会发送result_end通知消息，客户端close websocket连接
            // 非连续对话在这返回 continuous_decoding
          } else if (obj.type == 'server_error') {
            // 当发生异常或输入不合法时，服务器会发送server error消息
          }
        }
      };
      // 发生错误时
      websocket.onerror = evt => {
        console.error('websocket-asr错误：', evt);
        // todo 重连机制触发
      };
      // 关闭连接
      websocket.onclose = evt => {
        console.log('websocket-asr关闭：', evt);
      };
    };
    const closeWebsocket = () => {
      websocket && websocket.close();
      websocket = null;
    };
    const isFinshed = ref(true);
    const sendMessage = () => {
      if (!word.value || !isFinshed.value) return;
      stopRecord();
      closeWebsocket();
      textarea.value.style.height = 'inherit';
      isFinshed.value = false;
      getMessageTotalInfo(word.value, (status, num) => {
        if (status == 2) {
          word.value = '';
          isFinshed.value = true;
          ElMessage.warning('作为一个人工智能数字人，问题或答案超出了我的道德和法律规范，请换个问题');
          return;
        }
        bus.emit('chatmessage', {
          type: 'right',
          content: word.value
        });
        chatEvent((value, done) => {
          bus.emit('chatmessage', {
            type: 'left',
            content: value,
            done
          });
        });
      });
    };
    const {
      word,
      chatEvent
    } = chatgptHook(arr => {
      emits('uploadAudioStream', arr);
    });
    let {
      recStart,
      recStop
    } = jsRecorder(function (blob, encTime) {
      //发送音频blob
      if (websocket && isRecording.value) {
        websocket.send(blob);
      }
    });
    expose({});
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _directive_outsideClick = _resolveDirective("outsideClick");
      return _openBlock(), _createBlock(_component_el_popover, {
        "popper-class": "cus-popper",
        placement: "top-start",
        width: "auto",
        trigger: "click",
        "show-arrow": false,
        visible: _unref(visible)
      }, {
        reference: _withCtx(() => {
          var _ctx$$route$query, _ctx$$route$query2, _ctx$$route$query3, _ctx$$route$query4, _ctx$$route$query5;
          return [_createElementVNode("div", {
            class: "chatbox_container",
            onClick: emitPlayer
          }, [((_ctx$$route$query = _ctx.$route.query) === null || _ctx$$route$query === void 0 ? void 0 : _ctx$$route$query.type) == 'show' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelList, (vo, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", {
                item_active: _ctx.curLabelIndex === index
              }]),
              onClick: $event => _ctx.selectLabel(vo, index),
              key: index
            }, _toDisplayString(vo.name), 11, _hoisted_19);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
            class: "avatar_select cursor-p",
            style: _normalizeStyle({
              'pointer-events': ((_ctx$$route$query2 = _ctx.$route.query) === null || _ctx$$route$query2 === void 0 ? void 0 : _ctx$$route$query2.type) == 'show' ? 'none' : ''
            }),
            onClick: selectAvatar
          }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
            src: _unref(curSelectRoleInfo).digitalManImg,
            alt: ""
          }, null, 8, _hoisted_21)]), _unref(visible) ? (_openBlock(), _createElementBlock("img", _hoisted_22)) : _createCommentVNode("", true)], 4), _withDirectives(_createElementVNode("textarea", {
            style: _normalizeStyle({
              'pointer-events': ((_ctx$$route$query3 = _ctx.$route.query) === null || _ctx$$route$query3 === void 0 ? void 0 : _ctx$$route$query3.type) == 'show' ? 'none' : ''
            }),
            maxlength: "800",
            ref_key: "textarea",
            ref: textarea,
            onInput: input,
            rows: "1",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(word) ? word.value = $event : null),
            placeholder: _unref(placeholder),
            onKeydown: _withModifiers(messageSendlisten, ["stop"]),
            onFocus: _cache[1] || (_cache[1] = $event => _unref(set_visible)(false))
          }, null, 44, _hoisted_23), [[_vModelText, _unref(word), void 0, {
            trim: true
          }]]), !_unref(isRecording) ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            style: _normalizeStyle({
              'pointer-events': ((_ctx$$route$query4 = _ctx.$route.query) === null || _ctx$$route$query4 === void 0 ? void 0 : _ctx$$route$query4.type) == 'show' ? 'none' : ''
            }),
            onClick: startRecord,
            class: "icon sound",
            iconClass: "sound2"
          }, null, 8, ["style"])) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            onClick: stopRecord,
            class: "icon sound_end",
            iconClass: "soundEnd"
          })), _createElementVNode("div", {
            style: _normalizeStyle({
              'pointer-events': ((_ctx$$route$query5 = _ctx.$route.query) === null || _ctx$$route$query5 === void 0 ? void 0 : _ctx$$route$query5.type) == 'show' ? 'none' : ''
            }),
            onClick: sendMessage,
            class: _normalizeClass(["icon send_btn", {
              send_btn_dis: !_unref(word) || !_unref(isFinshed)
            }])
          }, _hoisted_25, 6)])];
        }),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(avatarList), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["avatar_item", {
              avatar_item_select: _unref(curSelectRoleInfo).id == item.id
            }]),
            onClick: $event => slectAvatar(item, index),
            key: index
          }, [item.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
            src: item.digitalManImg,
            alt: ""
          }, null, 8, _hoisted_4)])) : [1, 4].includes(item.status) ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8)) : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12)), _createElementVNode("span", {
            class: "ellipsis",
            title: item.name
          }, _toDisplayString(item.name), 9, _hoisted_13)], 10, _hoisted_2);
        }), 128)), _createElementVNode("div", {
          onClick: _withModifiers(addAvatar, ["stop"]),
          class: "avatar_item add_avatar"
        }, _hoisted_17, 8, _hoisted_14)])), [[_directive_outsideClick, outClick, "avatar_select"]])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
});